"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (o) {
          return typeof o;
        }
        : function (o) {
          return o &&
            "function" == typeof Symbol &&
            o.constructor === Symbol &&
            o !== Symbol.prototype
            ? "symbol"
            : typeof o;
        }),
    _typeof(o)
  );
}
function _createForOfIteratorHelper(r, e) {
  var t =
    ("undefined" != typeof Symbol && r[Symbol.iterator]) || r["@@iterator"];
  if (!t) {
    if (
      Array.isArray(r) ||
      (t = _unsupportedIterableToArray(r)) ||
      (e && r && "number" == typeof r.length)
    ) {
      t && (r = t);
      var _n = 0,
        F = function F() { };
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] };
        },
        e: function e(r) {
          throw r;
        },
        f: F,
      };
    }
    throw new TypeError(
      "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
    );
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return ((a = r.done), r);
    },
    e: function e(r) {
      ((u = !0), (o = r));
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    },
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    (r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o));
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (
    (r = _toPropertyKey(r)) in e
      ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0,
      })
      : (e[r] = t),
    e
  );
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return (
    _arrayWithoutHoles(r) ||
    _iterableToArray(r) ||
    _unsupportedIterableToArray(r) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return (
      "Object" === t && r.constructor && (t = r.constructor.name),
      "Map" === t || "Set" === t
        ? Array.from(r)
        : "Arguments" === t ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
          ? _arrayLikeToArray(r, a)
          : void 0
    );
  }
}
function _iterableToArray(r) {
  if (
    ("undefined" != typeof Symbol && null != r[Symbol.iterator]) ||
    null != r["@@iterator"]
  )
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

window.theme = window.theme || {};
(function ($) {
  "use strict";
  var config = {
    // apiUrl: "https://staging-api-101397235630.australia-southeast1.run.app",
    apiUrl: 'https://production-api-101397235630.australia-southeast1.run.app',
    storefrontApiUrl: "/api/2021-07/graphql.json",
    storefrontAccessToken: "8417a9536e8d3d7e4eb45452250eed42",
    captcha_site_key: "6LextFosAAAAAH3nCeeqSd1g50XqeAfURZOt8Z6a",
  };
  theme.ENV = $.extend(config);
  theme.API_CACHE_TTL = 20; // Cache duration in minutes

  theme.utils = {
    uuid: function uuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    setCookie: function setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 60 * 60 * 1000); //1h
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    fetch: function (url, options) {
      var isGet =
        !options || !options.method || options.method.toUpperCase() === "GET";
      // Cache GET requests to improve performance, but skip cart calls to keep badge/state fresh
      var isCart = url.indexOf("/cart") !== -1;
      var shouldCache = isGet && !isCart;
      var cacheKey =
        "theme_api_cache_" +
        url +
        (options && options.body ? "_" + JSON.stringify(options.body) : "");

      if (shouldCache) {
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          try {
            var parsed = JSON.parse(cached);
            var ttl = (theme.API_CACHE_TTL || 20) * 60 * 1000;
            if (Date.now() - parsed.timestamp < ttl) {
              // console.log('API Cache Hit:', url);
              return Promise.resolve(parsed.data);
            }
          } catch (e) {
            sessionStorage.removeItem(cacheKey);
          }
        }
      }

      return new Promise(function (resolve, reject) {
        window
          .fetch(url, options)
          .then(function (response) {
            response
              .json()
              .then(function (data) {
                if (response.status >= 400) {
                  reject(data);
                } else {
                  if (shouldCache) {
                    try {
                      sessionStorage.setItem(
                        cacheKey,
                        JSON.stringify({
                          data: data,
                          timestamp: Date.now(),
                        }),
                      );
                    } catch (e) {
                      console.warn("SessionStorage error:", e);
                    }
                  }
                  resolve(data);
                }
              })
            ["catch"](function (err) {
              if (response.status >= 400) reject(err);
              else resolve(response);
            });
          })
        ["catch"](function (error) {
          reject(error);
        });
      });
    },
    debounce: function debounce(func) {
      var _this2 = this;
      var timeout =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var timer;
      return function () {
        for (
          var _len = arguments.length, args = new Array(_len), _key = 0;
          _key < _len;
          _key++
        ) {
          args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(_this2, args);
        }, timeout);
      };
    },
    replaceUrlParam: function replaceUrlParam(url, paramName, paramValue) {
      if (paramValue == null) {
        paramValue = "";
      }
      var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
      if (url.search(pattern) >= 0) {
        return url.replace(pattern, "$1" + paramValue + "$2");
      }
      url = url.replace(/[?#]$/, "");
      return (
        url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
      );
    },
    updateBadge: function updateBadge() {
      var onCartPage = window.location.pathname == "/cart";
      var needReload =
        onCartPage && theme.utils.getCookie("cart_refreshed") != 1;
      fetch("/cart.js")
        .then(function (response) {
          return response.json().then(function (data) {
            if (response.ok) return data;
            throw Error(data.description);
          });
        })
        .then(function (data) {
          var _data$items;
          if (
            (_data$items = data.items) !== null &&
            _data$items !== void 0 &&
            _data$items.find(function (item) {
              return !item.price;
            })
          ) {
            theme.utils.setCookie("cart_refreshed", 0);
            $(".mini-cart__right").find(".loader-back").show();
            setTimeout(function () {
              theme.utils.updateBadge();
            }, 2000);
            return;
          }
          $(".mini-cart__right").find(".loader-back").hide();
          if (data && data.items.length > 0) {
            if (needReload) {
              theme.utils.setCookie("cart_refreshed", 1);
              window.location.reload();
              return;
            }
            if (onCartPage) {

            }
            $(".mini-cart__left__number").text(data.items.length);
            var price = data.total_price / 100.0;
            $(".mini-cart__right")
              .find(".amount")
              .text("$".concat(price.toFixed(2)));
            window.cart = data;
          } else {
            $(".mini-cart__left__number").text("0");
            $(".mini-cart__right").find(".amount").text("$0.00");
          }
        })
      ["catch"](function (err) {
        console.error(err);
        $(".mini-cart__left__number").text("0");
        $(".mini-cart__right").find(".amount").text("$0.00");
      })
      ["finally"](function () { });
    },
  };
  theme.a11y = {
    trapFocus: function trapFocus(options) {
      var element =
        typeof options.element === "string"
          ? $(options.element)
          : options.element;
      var elementToFocus =
        typeof options.elementToFocus === "string"
          ? $(options.elementToFocus)
          : options.elementToFocus;

      // Get every possible visible focusable element
      var focusableEls = element.find(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(function (el) {
        return el.offsetParent !== null;
      });
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      if (!elementToFocus) {
        elementToFocus = element;
      }
      element.attr("tabindex", "-1");
      elementToFocus.focus();
      var $document = $(document.documentElement);
      $document.off("focusin");
      $document.on("focusout", function () {
        $document.off("keydown.handleFocus");
      });
      $document.on("focusin", function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;
        $document.on("keydown.handleFocus", function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function removeTrapFocus(element) {
      var el = element
        ? typeof element === "string"
          ? $(element)
          : element
        : $(document.documentElement);
      el.removeAttr("tabindex");
      el.off("focusin");
    },
    lockScrolling: function lockScrolling(element) {
      var el = element
        ? typeof element === "string"
          ? $(element)
          : element
        : $(document.documentElement);
      el.addClass("lock-scroll");
      el.on("touchmove", function () {
        return true;
      });
    },
    unlockScrolling: function unlockScrolling(element) {
      var el = element
        ? typeof element === "string"
          ? $(element)
          : element
        : $(document.documentElement);
      el.removeClass("lock-scroll");
      el.off("touchmove");
    },
  };
  theme.Toggle = (function () {
    Toggle.prototype.el = null;
    Toggle.prototype.tabs = null;
    Toggle.prototype.panels = null;

    function Toggle(toggleClass) {
      this.el = $(toggleClass);
      this.tabs = this.el.find(".tab");
      this.panels = this.el.find(".panel");
      this.bind();
    }
    Toggle.prototype.show = function (index) {
      var activePanel, activeTab;
      this.tabs.removeClass("active");
      activeTab = this.tabs.get(index);
      $(activeTab).addClass("active");
      this.panels.hide();
      activePanel = this.panels.get(index);
      return $(activePanel).show();
    };
    Toggle.prototype.bind = function () {
      var _this = this;
      return this.tabs.unbind("click").bind("click", function (e) {
        return _this.show($(e.currentTarget).index());
      });
    };
    return Toggle;
  })();
  theme.Currency = (function () {
    var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(number) || number === null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
    return {
      formatMoney: formatMoney,
    };
  })();
  theme.Forms = (function () {
    function Forms() {
      var self = this;
      this.sampleFormButton = $("#product-addtosample-button");
      if (this.sampleFormButton.length > 0) {
        this._fetchDealers();
      }
    }
    Forms.prototype = Object.assign({}, Forms.prototype, {
      _fetchDealers: function _fetchDealers() {
        var self = this;
        var url = theme.ENV.apiUrl + "/shopify/dealers";
        return theme.utils.fetch(url).then(function (data) {
          window.dealers = data;
        });
      },
    });
    return Forms;
  })();
  theme._initToggles = function () {
    if (document.querySelectorAll(".toggle").length > 0)
      return new theme.Toggle(".toggle");
  };
  theme._initForms = function () {
    this.forms = new theme.Forms();
  };
  $(function () {
    theme._initForms();
    theme._initToggles();
    theme.initStockManagement();
  });
})(jQuery);

/* Disclosure */
$(function () {
  var selectors = {
    openButton: ".disclosure__open-button",
    openButtonLink: ".disclosure__open-button a",
  };

  function init() {
    $(selectors.openButton).on("click", handleToggle);
  }

  function destroy() {
    $(selectors.openButton).off("click", handleToggle);
  }
  $(selectors.openButtonLink).on("click", handleChildClick);

  function handleToggle(event) {
    var ANIMATION_DURATION_MS = 200;
    var body = $(event.currentTarget).next();
    var isOpening = body.is(":hidden");
    body.slideToggle(ANIMATION_DURATION_MS);
    $(event.currentTarget).find(".icon").toggleClass("rotate-180");
    if (isOpening) {
      var isMobile = window.matchMedia("(max-width: 767px)").matches;

      if (!isMobile) return;

      setTimeout(function () {
        event.currentTarget.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }, ANIMATION_DURATION_MS);
    }
  }

  function handleChildClick(event) {
    event.stopPropagation();
  }
  init();
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", destroy);
});

(function ($) {
  "use strict";
  var theme = window.theme;

  /**
   * Shared quantity rules for PDP selector + bulk order table.
   * Decimal 0.1 qty applies ONLY to Lineal Metre (LM) UOM variants.
   * Roll length prefers custom.lineal_metres, falls back to custom.length.
   * custom.length is unreliable for this: some variants store it in a
   * different unit (e.g. mm) than lineal_metres/reel_length (metres) —
   * ticket 41786821, SKU 451978 had length=50000 vs lineal_metres=50.
   */
  theme.quantityRules = {
    // UOM Name only — ignore product_type ("Lineal Metres" appears on REEL SKUs too).
    isLmUom: function (uomName) {
      var uom = String(uomName || "")
        .trim()
        .toLowerCase();
      return (
        uom === "lm" ||
        uom === "lineal metre" ||
        uom === "lineal metres" ||
        uom === "lineal meter" ||
        uom === "lineal meters"
      );
    },
    resolveRollLength: function (matchedVariant) {
      if (!matchedVariant) return 0;
      var lmRaw = parseFloat(matchedVariant.lineal_metres);
      if (lmRaw > 0) return lmRaw;
      return parseFloat(matchedVariant.length) || 0;
    },
    isDecimalLm: function (lmRaw) {
      return lmRaw > 0 && lmRaw !== Math.trunc(lmRaw);
    },
    isWholeLm: function (lmRaw) {
      return lmRaw > 0 && lmRaw === Math.trunc(lmRaw);
    },
    fromVariant: function (matchedVariant) {
      var rawOrderMultiple = matchedVariant && matchedVariant.order_multiple;
      // Blank/absent metafield vs explicitly "1" must stay distinguishable:
      // an explicit order_multiple (even 1) means "no roll restriction" and
      // must not be overridden by the whole-roll-length inference below.
      var orderMultipleBlank =
        rawOrderMultiple === "" ||
        rawOrderMultiple === null ||
        rawOrderMultiple === undefined;
      var orderMultiple = parseInt(rawOrderMultiple) || 1;
      var isLmUom = theme.quantityRules.isLmUom(
        matchedVariant && matchedVariant.uom_name,
      );
      // Decimal 0.1 qty / roll multiples: LM UOM only, prefer Length metafield
      var lmRaw = isLmUom
        ? theme.quantityRules.resolveRollLength(matchedVariant)
        : 0;
      var isDecimalLm = isLmUom && theme.quantityRules.isDecimalLm(lmRaw);
      var isWholeLm = isLmUom && theme.quantityRules.isWholeLm(lmRaw);
      var moq =
        orderMultiple > 1
          ? orderMultiple
          : isWholeLm && lmRaw > 1 && orderMultipleBlank
            ? lmRaw
            : 1;
      return {
        orderMultiple: orderMultiple,
        lmRaw: lmRaw,
        isLmUom: isLmUom,
        isDecimalLm: isDecimalLm,
        isWholeLm: isWholeLm,
        moq: moq,
      };
    },
    applyToInput: function (qtyInput, rules) {
      if (!qtyInput || !rules) return;
      if (rules.isDecimalLm) {
        qtyInput.step = 1;
        qtyInput.min = 1;
        qtyInput.setAttribute("data-lm", rules.lmRaw);
        qtyInput.removeAttribute("data-multiplier");
        qtyInput.removeAttribute("data-restrict-qty");
      } else {
        qtyInput.removeAttribute("data-lm");
        qtyInput.step = rules.moq > 1 ? rules.moq : 1;
        qtyInput.min = rules.moq > 1 ? rules.moq : 1;
        if (rules.moq > 1) {
          qtyInput.setAttribute("data-multiplier", rules.moq);
          qtyInput.setAttribute("data-restrict-qty", "true");
        } else {
          qtyInput.removeAttribute("data-multiplier");
          qtyInput.removeAttribute("data-restrict-qty");
        }
      }
    },
    hasLinealMetres: function (input) {
      if (!input) return false;
      var attr = input.getAttribute("data-lm");
      return attr !== null && attr !== "" && parseFloat(attr) > 0;
    },
    // Valid LM quantities are whole units (1, 2, 3, ...) OR exact multiples of
    // lmMultiplier (e.g. 30.4, 60.8 for a 30.4m roll). A whole number is
    // ALWAYS accepted, even if it isn't itself a multiple of the roll length.
    // A non-matching decimal is rejected with the nearest roll multiples
    // below and above it, so the caller can offer both as explicit choices —
    // below is omitted when the value is under one full roll.
    evaluateLmQuantity: function (value, lmMultiplier) {
      var lmVal = parseFloat(value) || 0;
      var lmMult = parseFloat(lmMultiplier) || 0;
      var isWhole = lmVal === Math.trunc(lmVal);
      if (lmMult <= 0 || isWhole) {
        return { accepted: true };
      }
      var safeLmVal = Math.round(lmVal * 1000);
      var safeLmMult = Math.round(lmMult * 1000);
      if (safeLmVal % safeLmMult === 0) {
        return { accepted: true };
      }
      var roundUp = +(Math.ceil(safeLmVal / safeLmMult) * lmMult).toFixed(2);
      var downMultiples = Math.floor(safeLmVal / safeLmMult);
      var roundDown = downMultiples > 0 ? +(downMultiples * lmMult).toFixed(2) : null;
      return { accepted: false, roundDown: roundDown, roundUp: roundUp };
    },
    // Shows the "sold in full rolls of X" choice dialog (round down / round
    // up, or just round up to 1 roll when below a full roll) and calls
    // onChoose(value) only if the shopper picks one — never silently.
    promptLmRollChoice: function (lmMultiplier, evalResult, onChoose) {
      if (!window.vex || !window.vex.dialog) {
        var fallbackValue = evalResult.roundDown || evalResult.roundUp;
        if (window.confirm("This product is sold in full rolls of " + lmMultiplier + " lm. Round to " + fallbackValue + "?")) {
          onChoose(fallbackValue);
        }
        return;
      }
      var buttons;
      var message;
      if (evalResult.roundDown) {
        message =
          "This product is sold in full rolls of " + lmMultiplier +
          " lm. Would you like to round down to " + evalResult.roundDown +
          " or round up to " + evalResult.roundUp + "?";
        buttons = [
          {
            text: "Round down to " + evalResult.roundDown,
            type: "submit",
            className: "vex-dialog-button-primary button-primary button",
            click: function () {
              this.value = evalResult.roundDown;
            },
          },
          {
            text: "Round up to " + evalResult.roundUp,
            type: "submit",
            className: "vex-dialog-button-primary button-primary button",
            click: function () {
              this.value = evalResult.roundUp;
            },
          },
          window.vex.dialog.buttons.NO,
        ];
      } else {
        message =
          "This product is sold in full rolls of " + lmMultiplier +
          " lm. Would you like to order 1 roll (" + evalResult.roundUp + ")?";
        buttons = [
          {
            text: "Order 1 roll (" + evalResult.roundUp + ")",
            type: "submit",
            className: "vex-dialog-button-primary button-primary button",
            click: function () {
              this.value = evalResult.roundUp;
            },
          },
          window.vex.dialog.buttons.NO,
        ];
      }
      window.vex.dialog.open({
        message: message,
        buttons: buttons,
        callback: function (value) {
          if (value) onChoose(value);
        },
      });
    },
    // Blocks an invalid LM quantity on a real input: reverts the field to
    // lastValidValue and shows the round-choice prompt. Returns true if the
    // current value was accepted (nothing to block), false if it was
    // rejected and the prompt is now showing.
    blockInvalidLmQuantity: function (qtyInput, lastValidValue) {
      if (!qtyInput || !theme.quantityRules.hasLinealMetres(qtyInput)) return true;
      var lmMultiplier = parseFloat(qtyInput.getAttribute("data-lm")) || 0;
      var lmVal = parseFloat(qtyInput.value) || 0;
      var evalResult = theme.quantityRules.evaluateLmQuantity(lmVal, lmMultiplier);
      if (evalResult.accepted) return true;
      qtyInput.value = lastValidValue || lmMultiplier;
      theme.quantityRules.promptLmRollChoice(lmMultiplier, evalResult, function (chosenValue) {
        qtyInput.value = chosenValue;
      });
      return false;
    },
    confirmQuantity: function (msg, idPrefix, onConfirm, onCancel) {
      if (window.vex && window.vex.dialog) {
        var appendLoc = "body";
        var wrapperDialog = null;
        if (document.querySelector(".quick-add-modal[open]")) {
          wrapperDialog = document.createElement("dialog");
          var uniqueId = idPrefix + Date.now();
          wrapperDialog.id = uniqueId;
          wrapperDialog.style.cssText =
            "width: 100vw; height: 100vh; background: transparent; border: none; padding: 0; margin: 0; max-width: none; max-height: none; overflow: hidden;";
          document.body.appendChild(wrapperDialog);
          wrapperDialog.showModal();
          appendLoc = "#" + uniqueId;
        }
        window.vex.dialog.confirm({
          message: msg,
          appendLocation: appendLoc,
          callback: function (value) {
            if (value) onConfirm();
            else onCancel();
            if (wrapperDialog) {
              setTimeout(function () {
                if (wrapperDialog.open) wrapperDialog.close();
                wrapperDialog.remove();
              }, 500);
            }
          },
        });
      } else if (confirm(msg)) {
        onConfirm();
      } else {
        onCancel();
      }
    },
    validateOnBlur: function ($input) {
      var input = $input && $input[0];
      var $container = $input.closest(
        "tr, .inner-grid, .product-form-buttons, .product-information, .quick-add-modal__content, .carts_items",
      );
      var noteEl = $container.find(".quntity-note[data-multiplier]");
      var hasLm = theme.quantityRules.hasLinealMetres(input);

      if (hasLm) {
        // Every input[name="quantity"] is rendered inside
        // <quantity-selector-component> (snippets/quantity-selector.liquid),
        // which already runs this same LM round-multiple check on its own
        // blur handler (component-quantity-selector.js #checkQuantityRules).
        // Re-checking here would show a second, duplicate prompt.
        return;
      }

      if (noteEl.length) {
        var multiplier = parseFloat(noteEl.attr("data-multiplier")) || 1;
        if (multiplier <= 1) {
          // Non-LM, no real MOQ: whole numbers only (REEL / PK etc.)
          var plainVal = parseFloat($input.val()) || 0;
          if (plainVal !== Math.trunc(plainVal)) {
            $input.val(Math.max(1, Math.round(plainVal)));
          }
          return;
        }
        var val = parseFloat($input.val()) || 0;
        var safeVal = Math.round(val * 1000);
        var safeMult = Math.round(multiplier * 1000);
        if (safeVal % safeMult !== 0) {
          var nearest_moq = Math.max(
            multiplier,
            Math.ceil(safeVal / safeMult) * multiplier,
          );
          if (nearest_moq % 1 !== 0) nearest_moq = +nearest_moq.toFixed(2);
          var msg =
            "Order quantity must be in multiples of " +
            multiplier +
            " for this product - would you like to update order quantity to " +
            nearest_moq +
            "?";
          theme.quantityRules.confirmQuantity(
            msg,
            "moq-vex-wrapper-pdp-",
            function () {
              $input.val(nearest_moq);
            },
            function () {
              $input.val(multiplier);
            },
          );
        }
      } else {
        // No MOQ note and not LM: force whole numbers (Our Range REEL rows)
        var wholeVal = parseFloat($input.val()) || 0;
        if (wholeVal !== Math.trunc(wholeVal)) {
          $input.val(Math.max(1, Math.round(wholeVal)));
        }
      }
    },
  };

  theme.updateStockDisplay = async function (material, container, passedQty) {
    // if (!window.customer || !window.customer.id) return; // SKIP for guest users

    var isPDP = container === document.body;
    var isBulkRow =
      container.classList && (
        container.classList.contains("variant-row") ||
        container.classList.contains("inner-grid")
      );

    var stockEls;
    if (isPDP) {
      stockEls = document.querySelectorAll(
        ".product-details .product-inventory__status, .product-details .in-stock, .product-details .out-stock, .product-details .low-stock, " +
        ".product-information .product-inventory__status, .product-information .in-stock, .product-information .out-stock, .product-information .low-stock, " +
        ".product__variants .product-inventory__status, .product__variants .in-stock, .product__variants .out-stock, .product__variants .low-stock, " +
        ".product__info .product-inventory__status, .product__info .in-stock, .product__info .out-stock, .product__info .low-stock, " +
        ".quick-add-modal__content .product-inventory__status, .quick-add-modal__content .in-stock, .quick-add-modal__content .out-stock, .quick-add-modal__content .low-stock"
      );
    } else {
      stockEls = container.querySelectorAll(
        ".product-inventory__status, .in-stock, .out-stock, .low-stock"
      );
    }

    stockEls.forEach(function (el) {
      el.classList.add("blur");
    });

    // ✅ FIX 3: Use passed qty (from actual row input) when available, otherwise default to 1
    var qty = (passedQty && passedQty > 0) ? passedQty : 1;

    // ✅ All products now use /stock-template-by-material API
    // ✅ FIX 1: Add context param to isolate cache between bulk rows and PDP/QuickOrder calls
    var postcode = theme.utils.getCookie('postcode') || (window.customer ? window.customer.postcode : '') || '3000';
    var customer = window.customer ? window.customer.sapId : '';

    var url =
      theme.ENV.apiUrl +
      "/stock-template-by-material?materialNo=" +
      material +
      "&qty=" +
      qty +
      "&postcode=" +
      postcode;
    if (customer) url += "&customer=" + customer;
    if (isBulkRow) url += "&context=bulk";

    /* ❌ OLD: Paper-only logic — commented out, now all products use stock-template-by-material
        var isPaper = document.body.classList.contains('product-template-paper');
        var url = '';
        if (isPaper) {
            url = theme.ENV.apiUrl + '/stock-template-by-material?materialNo=' + material + '&qty=' + qty + '&postcode=' + postcode;
            if (customer) url += '&customer=' + customer;
        } else {
            var plant = window.customer ? window.customer.plant : '';
            url = theme.ENV.apiUrl + '/stock?materialNo=' + material + '&postcode=' + postcode;
            if (plant) url += '&plant=' + plant;
        }
        */
    try {
      var response = await theme.utils.fetch(url);
      console.log("Stock API Raw Data:", response);
      var parsedData;

      if (response && response.data) {
        // ✅ Handle new JSON API format
        parsedData = response.data;
        parsedData.quantity = response.data.soh || 0;
      } else if (
        typeof response === "number" ||
        (typeof response === "string" &&
          !isNaN(response) &&
          response.length > 0)
      ) {
        // Fallback for raw numbers
        var qtyVal = parseInt(response);
        parsedData = {
          level: qtyVal > 10 ? "GREEN" : qtyVal > 0 ? "AMBER" : "RED",
          message:
            qtyVal > 0
              ? qtyVal > 10
                ? "In Stock"
                : "Low Stock"
              : "Out of Stock",
          capabilities: { addToCart: qtyVal > 0 },
          quantity: qtyVal,
        };
      } else if (typeof response === "string" && response.length > 0) {
        // Fallback for direct messages (like "150 IN STOCK")
        var hasStock =
          response.toLowerCase().indexOf("in stock") !== -1 ||
          response.toLowerCase().indexOf("low stock") !== -1;
        parsedData = {
          level: hasStock ? "GREEN" : "RED",
          message: response,
          capabilities: { addToCart: hasStock },
          quantity: parseInt(response) || 0,
        };
      } else {
        parsedData = response; // Default fallback
      }

      theme.applyStockUI(parsedData, container);
    } catch (err) {
      console.error("Stock Update Error:", err);
    } finally {
      // ✅ FIX Issue 2: Re-query elements fresh after applyStockUI may have changed classes
      var unblurEls;
      if (isPDP) {
        unblurEls = document.querySelectorAll(
          ".product-details .product-inventory__status, .product-details .product-inventory__text, .product-details .in-stock, .product-details .out-stock, .product-details .low-stock, " +
          ".product-information .product-inventory__status, .product-information .product-inventory__text, .product-information .in-stock, .product-information .out-stock, .product-information .low-stock, " +
          ".product__variants .product-inventory__status, .product__variants .product-inventory__text, .product__variants .in-stock, .product__variants .out-stock, .product__variants .low-stock, " +
          ".product__info .product-inventory__status, .product__info .product-inventory__text, .product__info .in-stock, .product__info .out-stock, .product__info .low-stock, " +
          ".quick-add-modal__content .product-inventory__status, .quick-add-modal__content .product-inventory__text, .quick-add-modal__content .in-stock, .quick-add-modal__content .out-stock, .quick-add-modal__content .low-stock"
        );
      } else {
        unblurEls = container.querySelectorAll(
          ".product-inventory__status, .product-inventory__text, .in-stock, .out-stock, .low-stock"
        );
      }
      unblurEls.forEach(function (el) {
        el.classList.remove("blur");
      });
    }
  };

  theme.updatePriceDisplay = async function (material, prm, container) {
    // if (!window.customer || !window.customer.id) return; // SKIP for guest users

    var customer = window.customer ? window.customer.sapId : "143282";
    var qty = 1;
    var isPDP = container === document.body;
    var priceEls = isPDP
      ? document.querySelectorAll(
        ".product-information product-price .price, .product-details product-price .price, .product__variants product-price .price, .product__info product-price .price, .quick-add-modal__content .price",
      )
      : container.querySelectorAll(".price, .price-exc-gst, .price-inc-gst");

    if (!material || !prm || priceEls.length === 0) return;

    priceEls.forEach(function (el) {
      el.classList.add("blur");
    });

    var multiplier = 1;
    var uomName = "";

    if (isPDP) {
      var picker = document.querySelector("variant-picker");
      if (picker) {
        var opt =
          picker.querySelector(
            "select option:checked, fieldset input:checked",
          ) || picker.querySelector("select option");
        if (opt) {
          multiplier = Number(opt.dataset.multiplier || 1);
          uomName = opt.dataset.uomName || "";
        }
      } else {
        var priceContainer = document.querySelector('[ref="priceContainer"]');
        if (priceContainer) {
          multiplier = Number(priceContainer.dataset.multiplier || 1);
          uomName = priceContainer.dataset.uomName || "";
        }
      }
    } else {
      // Check container itself (e.g. bulk order row)
      if (container.dataset && container.dataset.multiplier !== undefined) {
        multiplier = Number(container.dataset.multiplier || 1);
        uomName = container.dataset.uomName || "";
      } else {
        // Check if there is an active picker inside container (e.g. quick-add modal)
        var picker = container.querySelector("variant-picker");
        if (picker) {
          var opt =
            picker.querySelector(
              "select option:checked, fieldset input:checked",
            ) || picker.querySelector("select option");
          if (opt) {
            multiplier = Number(opt.dataset.multiplier || 1);
            uomName = opt.dataset.uomName || "";
          }
        } else {
          var priceContainer = container.querySelector(
            '[ref="priceContainer"]',
          );
          if (priceContainer) {
            multiplier = Number(priceContainer.dataset.multiplier || 1);
            uomName = priceContainer.dataset.uomName || "";
          }
        }
      }
    }

    if (isNaN(multiplier) || multiplier <= 0) {
      multiplier = 1;
    }

    if (multiplier === 1 && uomName) {
      var uomLower = uomName.toLowerCase();
      if (uomLower.indexOf("1000") !== -1) {
        multiplier = 1000;
      } else if (uomLower.indexOf("100") !== -1) {
        multiplier = 100;
      } else if (uomLower.indexOf("10") !== -1) {
        multiplier = 10;
      }
    }

    // ✅ BULK ORDER FIX: Handle paper products where uomName = "SHEET" (no numeric prefix).
    // For paper template rows, if uomName is "SHEET"/"SHEETS" with no quantity prefix,
    // default multiplier to 1000 (matching Liquid logic).
    // Also handle blank uomName by checking DOM suffix text.
    if (multiplier === 1) {
      var rowTemplate = "";
      if (isPDP) {
        // On PDP, read template suffix from body class or window.current
        rowTemplate =
          (window.current &&
            window.current.template &&
            window.current.template.suffix) ||
          "";
      } else {
        rowTemplate = container.dataset
          ? container.dataset.productTemplate || ""
          : "";
      }
      var isPaperRow = rowTemplate === "paper";
      var uomLower2 = uomName ? uomName.trim().toLowerCase() : "";

      if (isPaperRow && (uomLower2 === "sheet" || uomLower2 === "sheets")) {
        // Paper product with bare "SHEET" uom — 1000 sheets per order unit
        multiplier = 1000;
        uomName = "1000 " + uomName.trim();
      } else if (!uomName && !isPDP) {
        // Fallback: detect from Liquid-rendered DOM suffix text node
        var incGstEl = container.querySelector(".price-inc-gst");
        if (incGstEl && incGstEl.parentNode) {
          var siblingText = "";
          incGstEl.parentNode.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              siblingText += node.textContent;
            }
          });
          siblingText = siblingText.trim();
          if (siblingText.indexOf("1000") !== -1) {
            multiplier = 1000;
            uomName = siblingText.replace(/^\/\s*/, "").trim();
          } else if (siblingText.indexOf("100") !== -1) {
            multiplier = 100;
            uomName = siblingText.replace(/^\/\s*/, "").trim();
          } else if (siblingText.indexOf("10") !== -1) {
            multiplier = 10;
            uomName = siblingText.replace(/^\/\s*/, "").trim();
          }
        }
      }
    }

    var url =
      theme.ENV.apiUrl +
      "/customers/pricing/" +
      prm +
      "?material=" +
      material +
      "&qty=" +
      qty +
      "&customer=" +
      customer;

    try {
      var response = await theme.utils.fetch(url);
      var rawPrice =
        response && response.data && response.data.price !== undefined
          ? response.data.price
          : response && response.price !== undefined
            ? response.price
            : undefined;

      if (rawPrice !== undefined) {
        var origIncGstEl = container.querySelector(".price-inc-gst");
        var origPrice = 0;
        if (origIncGstEl) {
          origPrice = parseFloat(origIncGstEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        }

        var price = Number(rawPrice) * multiplier;

        // Safeguard against ERP returning an already multiplied price
        if (origPrice > 0 && price > (origPrice * 5) && multiplier > 1) {
          price = Number(rawPrice);
        }

        var priceExcGst = price / 1.1;
        var formattedPrice = "$" + price.toFixed(2);
        var formattedPriceNoGst = "$" + priceExcGst.toFixed(2);
        var priceExcGstCents = Math.round(priceExcGst * 100);
        var unitPriceCents = (Number(rawPrice) / 1.1) * 100;
        var targetContainer = isPDP ? document : container;

        // ✅ BUG FIX: When isPDP, exclude bulk order rows from price update
        // so PDP variant change doesn't overwrite individual bulk order row prices.
        function getNonBulkEls(selector) {
          var all = Array.from(targetContainer.querySelectorAll(selector));
          if (isPDP) {
            all = all.filter(function (el) {
              return !el.closest(
                ".bulk-order-section, .variant-row, .bulk-order.mobile .inner-grid",
              );
            });
          }
          return all;
        }

        var excGstEls = getNonBulkEls(".price-exc-gst");
        var incGstEls = getNonBulkEls(".price-inc-gst");

        if (excGstEls.length > 0) {
          excGstEls.forEach(function (el) {
            el.textContent = formattedPriceNoGst;
          });
        }
        if (incGstEls.length > 0) {
          incGstEls.forEach(function (el) {
            el.textContent = formattedPrice;
          });
        }

        // Fallback for other standard price elements
        if (excGstEls.length === 0 && incGstEls.length === 0) {
          priceEls.forEach(function (el) {
            el.textContent = formattedPrice;
          });
        }

        // Update the UOM suffix dynamically if .price-uom exists
        var unitName = "";
        if (uomName && uomName.trim() !== "") {
          var uomStr = uomName.trim();
          // Avoid double-prefix: if uomName already starts with the multiplier number, don't repeat it
          var startsWithMultiplier =
            multiplier > 1 && uomStr.indexOf(String(multiplier)) === 0;
          if (multiplier > 1 && !startsWithMultiplier) {
            unitName = " / " + multiplier + " " + uomStr;
          } else {
            unitName = " / " + uomStr;
          }
        }
        var uomEls = targetContainer.querySelectorAll(".price-uom");
        if (uomEls.length > 0) {
          uomEls.forEach(function (el) {
            el.textContent = unitName;
          });
        }

        // ✅ FIX: Update data-unit-price on priceContainer so handleQuantityUpdate
        // in product-price.js uses the API price (cents) instead of stale Shopify price.
        // product-price.js: unitPrice = parseFloat(priceContainer.dataset.unitPrice)
        // then totalPrice = unitPrice * quantity → must be in cents format
        var priceContainers = targetContainer.querySelectorAll(
          '[ref="priceContainer"]',
        );
        priceContainers.forEach(function (pc) {
          pc.dataset.unitPrice = unitPriceCents;

          // ✅ MOQ FIX: After API price is set, trigger handleQuantityUpdate so
          // the displayed price reflects the current qty (e.g. MOQ=100 on page load).
          var productPriceEl = pc.closest("product-price");
          if (
            productPriceEl &&
            typeof productPriceEl.handleQuantityUpdate === "function"
          ) {
            productPriceEl.handleQuantityUpdate();
          }
        });
      }
    } catch (err) {
      console.error("Price Update Error:", err);
    } finally {
      priceEls.forEach(function (el) {
        el.classList.remove("blur");
      });
    }
  };

  theme.applyStockUI = function (data, container) {
    console.log("--- ApplyStockUI Start ---", {
      material: data.material,
      level: data.level,
      container: container,
    });

    // Read template from container itself OR from an inner grid element (e.g. quick-add modal)
    var innerGrid = container.querySelector
      ? container.querySelector("[data-product-template]")
      : null;
    var rowTemplate =
      container.dataset && container.dataset.productTemplate
        ? container.dataset.productTemplate
        : innerGrid && innerGrid.dataset.productTemplate
          ? innerGrid.dataset.productTemplate
          : null;

    var rowColsRaw = container.dataset
      ? container.dataset.productCollections
      : null;
    var rowCols = [];
    try {
      if (rowColsRaw) rowCols = JSON.parse(rowColsRaw);
    } catch (e) { }

    var isRigid =
      rowTemplate === "rigid" ||
      document.body.classList.contains("product-template-rigid");
    var isPaper =
      rowTemplate === "paper" ||
      document.body.classList.contains("product-template-paper");
    var isWrap =
      rowTemplate === "wrap" ||
      document.body.classList.contains("product-template-wrap");

    // Fallback wrap detection if template is empty but collections have 'wrap'
    if (!isWrap && rowCols.length > 0) {
      isWrap = rowCols.some(function (c) {
        return c.indexOf("wrap") !== -1;
      });
    }

    var isNormal = !isRigid && !isPaper && !isWrap;
    var isPDP = container === document.body;

    // ✅ FIX 2+3: Scope stock element lookup to prevent overwriting other sections
    var isBulkRow =
      container.classList &&
      (container.classList.contains("variant-row") || container.classList.contains("inner-grid"));

    var stockTextEls, stockIconEls, atcButtons;

    if (isPDP) {
      // Only target main product area and quick add modals, skip bulk order table
      stockTextEls = document.querySelectorAll(
        ".product-details .product-inventory__text, .product-details .in-stock, .product-details .out-stock, .product-details .low-stock, " +
        ".product-information .product-inventory__text, .product-information .in-stock, .product-information .out-stock, .product-information .low-stock, " +
        ".product__variants .product-inventory__text, .product__variants .in-stock, .product__variants .out-stock, .product__variants .low-stock, " +
        ".product__info .product-inventory__text, .product__info .in-stock, .product__info .out-stock, .product__info .low-stock, " +
        ".quick-add-modal__content .product-inventory__text, .quick-add-modal__content .in-stock, .quick-add-modal__content .out-stock, .quick-add-modal__content .low-stock"
      );
      stockIconEls = document.querySelectorAll(
        ".product-details .product-inventory__icon, .product-details [class*='product-inventory__icon'], " +
        ".product-information .product-inventory__icon, .product-information [class*='product-inventory__icon'], " +
        ".product__variants .product-inventory__icon, .product__variants [class*='product-inventory__icon'], " +
        ".product__info .product-inventory__icon, .product__info [class*='product-inventory__icon'], " +
        ".quick-add-modal__content .product-inventory__icon, .quick-add-modal__content [class*='product-inventory__icon']"
      );
      atcButtons = document.querySelectorAll(
        ".product-details .add-to-cart, " +
        ".product-information .add-to-cart, " +
        ".product-form-buttons .add-to-cart, " +
        ".product__variants .add-to-cart, " +
        ".product__info .add-to-cart, " +
        ".quick-add-modal__content .add-to-cart"
      );
    } else {
      var stockScope = isBulkRow ? container : container;
      stockTextEls = stockScope.querySelectorAll(
        isBulkRow
          ? ".product-inventory__text, .in-stock, .out-stock, .low-stock"
          : ".product-inventory__text, .in-stock, .out-stock"
      );
      stockIconEls = container.querySelectorAll(
        '.product-inventory__icon, [class*="product-inventory__icon"]'
      );
      atcButtons = container.querySelectorAll('.add-to-cart, [name="add"]');
    }

    if (
      stockTextEls.length === 0 &&
      atcButtons.length === 0 &&
      stockIconEls.length === 0
    )
      return;

    var quantity = 0;
    var rawMsg = typeof data === "string" ? data : data.message || "";

    if (data.quantity !== undefined) {
      quantity = parseInt(data.quantity);
    } else if (data.soh !== undefined) {
      quantity = parseInt(data.soh);
    } else {
      var match = rawMsg.match(/\d+/);
      quantity = match ? parseInt(match[0]) : 0;
    }

    // ✅ FIX 4: Respect API-returned level when available, fall back to quantity-based calculation only when API level is absent
    var level;
    if (data.level && (data.level === "GREEN" || data.level === "AMBER" || data.level === "RED")) {
      level = data.level;
    } else {
      // Fallback: calculate from quantity when API does not supply a level
      level = quantity > 10 ? "GREEN" : (quantity > 0 ? "AMBER" : "RED");
    }

    var message = data.message;
    if (!message || message.trim() === "" || typeof data === "string") {
      if (typeof data === "string" && data.trim() !== "") {
        message = data;
      } else if (quantity > 0) {
        message = level === "GREEN" ? "In Stock" : "Limited Stock";
      } else {
        message = "Out of Stock";
      }
    }

    var canAdd = data.capabilities
      ? data.capabilities.addToCart
      : level !== "RED";

    // NEW LOGIC BASED ON UPDATED TABLE
    if (isRigid) {
      canAdd = false;
      if (level === "RED") {
        level = "AMBER";
        message = "Limited stock";
      } else if (level === "GREEN") {
        message = "In Stock";
      } else {
        message = "Limited stock";
      }
    } else if (isPaper) {
      // For paper products, use quantity to set message
      var isLoggedIn = window.customer && window.customer.id;
      if (level === "GREEN") {
        message = isLoggedIn ? "In Stock - " + quantity + " available" : "In Stock";
      } else if (level === "AMBER") {
        message = isLoggedIn ? "Limited Stock - " + quantity + " available" : "Limited Stock";
      } else {
        message = isLoggedIn ? "Out of Stock - " + quantity + " available" : "Out of Stock";
      }

      // Enforce out-of-stock logic (disable Add To Cart if RED)
      canAdd = level !== "RED";
    } else if (isWrap || isNormal) {
      if (level === "RED") {
        level = "AMBER";
      }
      canAdd = true;
      if (level === "GREEN") {
        message = "In Stock";
      } else {
        message = "Limited stock"; // Short message for Amber/Forced Amber
      }
    }

    console.log("Final State Decision:", {
      level: level,
      message: message,
      canAdd: canAdd,
    });

    if (stockTextEls.length > 0) {
      stockTextEls.forEach(function (el) {
        el.textContent = message;
        $(el).removeClass("in-stock out-stock low-stock");
        if (level === "GREEN") $(el).addClass("in-stock");
        else if (level === "AMBER") $(el).addClass("low-stock");
        else $(el).addClass("out-stock");
      });
    }

    if (stockIconEls.length > 0) {
      stockIconEls.forEach(function (el) {
        var lowClass =
          el.getAttribute("low-class") || "product-inventory__icon-low";
        var outClass =
          el.getAttribute("out-class") ||
          "product-inventory__icon-out_of_stock";

        $(el).removeClass(
          "product-inventory__icon-in_stock " + lowClass + " " + outClass,
        );
        if (level === "GREEN")
          $(el).addClass("product-inventory__icon-in_stock");
        else if (level === "AMBER") $(el).addClass(lowClass);
        else $(el).addClass(outClass);
      });
    }

    if (isPDP) {
      if (level === "GREEN") document.body.classList.add("in-stock-body");
      else document.body.classList.remove("in-stock-body");

      if (level === "AMBER") document.body.classList.add("low-stock");
      else document.body.classList.remove("low-stock");

      if (level === "RED" && isRigid) document.body.classList.add("out-stock");
      else document.body.classList.remove("out-stock");
    }

    // ATC buttons logic is now handled above where atcButtons is assigned

    atcButtons.forEach(function (btn) {
      var textEl = btn.querySelector(
        ".add-to-cart-text__content, .pdp-add-cart-text",
      );

      // Rigid products: ALWAYS disabled regardless of login status (business rule)
      var forceDisable = isRigid;

      if (!forceDisable && canAdd) {
        btn.disabled = false;
        btn.classList.remove("force-disabled");
        btn.removeAttribute("disabled");
        if (textEl) {
          if (
            isBulkRow ||
            btn.closest(".bulk-order-section, .variant-row, .inner-grid")
          ) {
            textEl.textContent = "Add to Order";
          } else {
            textEl.textContent = "Add to Cart";
          }
        }
      } else {
        btn.disabled = true;
        btn.classList.add("force-disabled");
        btn.setAttribute("disabled", "disabled");
      }
    });

    var qtyInputs = isPDP
      ? document.querySelectorAll("quantity-input input, quantity-input button")
      : container.querySelectorAll("quantity-input input, quantity-input button");
    qtyInputs.forEach(function (el) {
      if (canAdd) {
        el.disabled = false;
        el.removeAttribute("disabled");
      } else {
        el.disabled = true;
        el.setAttribute("disabled", "disabled");
      }
    });

    var qtyInput = container.querySelector('input[name="quantity"]');
    if (qtyInput) {
      if (data.quantity !== undefined) {
        qtyInput.setAttribute("max", data.quantity);
      }

      if (!theme.quantityRules.hasLinealMetres(qtyInput)) {
        var noteEl = container.querySelector(".quntity-note");
        if (noteEl && noteEl.hasAttribute("data-multiplier")) {
          var multiplier = parseInt(noteEl.getAttribute("data-multiplier"));
          if (multiplier > 1) {
            qtyInput.setAttribute("step", multiplier);
            qtyInput.setAttribute("min", multiplier);
            var currentVal = parseFloat(qtyInput.value) || 0;
            if (currentVal < multiplier || currentVal % multiplier !== 0) {
              qtyInput.value = multiplier;
            }
          }
        }
      }
    }
  };

  theme.handleAddToCart = function (e) {
    e.preventDefault();
    var $btn = $(e.currentTarget);
    var $modalContainer = $btn.closest(".quick-add-modal__content");
    var $container = $modalContainer.length
      ? $modalContainer
      : $btn.closest(
        ".product-details, .product-information, tr, .inner-grid, .product-form-buttons, .product-card, .quick-add, .bulk-order-section",
      );

    var qtyInput = $container.find('input[name="quantity"]');
    var quantity = Math.round((parseFloat(qtyInput.val()) || 1) * 10) / 10;
    if (theme.quantityRules.hasLinealMetres(qtyInput[0])) {
      // LM: must be whole units OR an exact multiple of the roll length —
      // block the add and show the round down/up choice prompt instead of
      // silently correcting, so the shopper explicitly picks the quantity.
      if (!theme.quantityRules.blockInvalidLmQuantity(qtyInput[0])) {
        return;
      }
      quantity = parseFloat(qtyInput.val()) || 1;
    } else {
      // Non-LM (no data-lm): whole numbers only — blocks typed 1.3 on REEL rows
      quantity = Math.max(1, Math.round(quantity));
      if (qtyInput.length && parseFloat(qtyInput.val()) !== quantity) {
        qtyInput.val(quantity);
      }
    }

    var selectedOpt = $container.find(
      'select[name="options[Title]"] option:selected',
    )[0];
    if (!selectedOpt) {
      selectedOpt = $container
        .find("select option:selected, input:checked")
        .filter(function () {
          var name = $(this).attr("name");
          return name !== "quantity" && name !== "id";
        })
        .first()[0];
    }

    if (!selectedOpt && !$modalContainer.length) {
      var $closestSection = $btn.closest(".shopify-section");
      if ($closestSection.length) {
        selectedOpt =
          $closestSection.find(
            'select[name="options[Title]"] option:selected',
          )[0] ||
          $closestSection
            .find(
              "variant-picker select option:selected, variant-picker input:checked",
            )
            .first()[0];
      }
    }

    var variantId = $btn.attr("data-id") || $btn.data("id");
    if (
      !variantId &&
      selectedOpt &&
      selectedOpt.dataset &&
      selectedOpt.dataset.variantId
    ) {
      variantId = selectedOpt.dataset.variantId;
    }
    if (!variantId) {
      variantId = $container.find('[name="id"]').val();
    }

    var noteEl = $container.find(".quntity-note[data-multiplier]");
    var qtyInputEl = qtyInput && qtyInput[0];
    if (noteEl.length && !theme.quantityRules.hasLinealMetres(qtyInputEl)) {
      var multiplier = parseInt(noteEl.attr("data-multiplier"));
      if (multiplier > 1 && quantity % multiplier !== 0) {
        alert("Quantity must be a multiple of " + multiplier);
        return;
      }
    }

    if (!variantId || quantity <= 0) return;

    $btn.addClass("is-loading");

    var noteEl = $container.find(".quntity-note[data-multiplier]");
    var moqMultiplier = 1;
    if (noteEl.length) {
      moqMultiplier = parseInt(noteEl.attr("data-multiplier")) || 1;
    }

    var prm =
      $container.find(".prm-input").val() ||
      $container.find('[name="prm"]').val() ||
      $container.find("#prm").val();
    if (
      !prm &&
      selectedOpt &&
      selectedOpt.dataset &&
      selectedOpt.dataset.prmValue
    ) {
      prm = selectedOpt.dataset.prmValue;
    }

    var hiddenIdInput = $container.find('input[name="id"]')[0];
    if (
      !prm &&
      hiddenIdInput &&
      hiddenIdInput.dataset &&
      hiddenIdInput.dataset.prmValue
    ) {
      prm = hiddenIdInput.dataset.prmValue;
    }
    // Bulk Order: read prm from variant-row tr's own data-prm-value attribute
    if (!prm && $container[0] && $container[0].dataset && $container[0].dataset.prmValue) {
      prm = $container[0].dataset.prmValue;
    }
    console.log('[ATC] prm:', prm, '| $container class:', $container.attr('class'));

    if (!prm) {
      var itemPayload = { id: variantId, quantity: quantity };
      if (moqMultiplier > 1) {
        itemPayload.properties = { _moq: moqMultiplier };
      }
      window
        .fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [itemPayload],
          }),
        })
        .then(async function (res) {
          if (!res.ok) {
            const errData = await res.json();
            throw new Error(errData.description || errData.message || "Error adding to cart");
          }
          return res.json();
        })
        .then(function (data) {
          if (typeof refreshCartDrawer === "function") refreshCartDrawer();
          theme.utils.updateBadge();
        })
        .finally(function () {
          $btn.removeClass("is-loading");
        })
        .catch(function (err) {
          console.error("[ATC] Error:", err);
          window.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { data: { message: err.message } } }));
          // Open drawer but skip DOM update to avoid wiping the error message
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { didError: true } } }));
        });
      return;
    }

    var material = "";
    if ($btn.data("material")) {
      material = $btn.data("material");
    } else if (
      selectedOpt &&
      selectedOpt.dataset &&
      selectedOpt.dataset.material
    ) {
      material = selectedOpt.dataset.material;
    } else if (
      $container[0] &&
      $container[0].dataset &&
      $container[0].dataset.material
    ) {
      // Bulk Order: read material from variant-row tr's own data-material attribute
      material = $container[0].dataset.material;
    } else if (
      hiddenIdInput &&
      hiddenIdInput.dataset &&
      hiddenIdInput.dataset.material
    ) {
      material = hiddenIdInput.dataset.material;
    } else if ($container.find(".sku").length) {
      material = $container.find(".sku").text().replace("SKU:", "").trim();
    }

    var properties = {};
    if (window.customer && window.customer.email) {
      properties._customer_email = window.customer.email;
    }
    if (moqMultiplier > 1) {
      properties._moq = moqMultiplier;
    }
    if (selectedOpt && selectedOpt.dataset) {
      // PDP: build properties from selected variant option's data attributes
      Object.keys(selectedOpt.dataset).forEach(function (key) {
        if (
          ["variantId", "material", "prmValue", "optionValueId"].indexOf(
            key,
          ) === -1
        ) {
          if (["color", "gsm", "width", "sheet", "multiplier", "uomName"].indexOf(key) !== -1) {
            properties["_" + key] = selectedOpt.dataset[key];
          } else {
            properties[key] = selectedOpt.dataset[key];
          }
        }
      });
    } else {
      // Bulk Order / Quick Order: build properties from variant-row container data attributes
      var $variantRow = $container.is(".variant-row, .inner-grid")
        ? $container
        : $container.closest(".variant-row, .inner-grid");
      console.log('[ATC] No selectedOpt. $container classes:', $container.attr('class'), '| $variantRow found:', $variantRow.length);

      var sourceData = null;
      if ($variantRow.length) {
        sourceData = $variantRow[0].dataset;
      } else if (hiddenIdInput && hiddenIdInput.dataset) {
        // Fallback to hidden id input for single-variant product cards on Collection page
        sourceData = hiddenIdInput.dataset;
      }

      if (sourceData) {
        console.log('[ATC] sourceData found:', JSON.stringify(sourceData));
        if (sourceData.color) properties._color = sourceData.color;
        if (sourceData.gsm) properties._gsm = sourceData.gsm;
        if (sourceData.width) properties._width = sourceData.width;
        if (sourceData.sheet) properties._sheet = sourceData.sheet;
        if (sourceData.uomName) properties._uomName = sourceData.uomName;
        if (sourceData.multiplier && parseInt(sourceData.multiplier) > 1) {
          properties._multiplier = sourceData.multiplier;
        }
      }
    }
    console.log('[ATC] Final properties before API call:', JSON.stringify(properties));

    grecaptcha.ready(function () {
      grecaptcha
        .execute(theme.ENV.captcha_site_key, { action: "submit" })
        .then(async function (token) {
          try {
            var cartRes = await window.fetch("/cart.js");
            var cartObj = await cartRes.json();
            var sapId =
              window.customer && window.customer.sapId
                ? window.customer.sapId
                : "143282";

            function normalizeProps(props) {
              var cleaned = {};
              Object.keys(props || {})
                .sort()
                .forEach(function (k) {
                  if (
                    k.charAt(0) !== "_" &&
                    k.toLowerCase() !== "qty" &&
                    k.toLowerCase() !== "quantity"
                  ) {
                    cleaned[k] = String(props[k]);
                  }
                });
              return JSON.stringify(cleaned);
            }

            var basePropsNorm = normalizeProps(properties);
            var existingLineIndex = -1;
            for (var j = 0; j < cartObj.items.length; j++) {
              if (
                cartObj.items[j].variant_id === parseInt(variantId) &&
                normalizeProps(cartObj.items[j].properties) === basePropsNorm
              ) {
                existingLineIndex = j;
                break;
              }
            }

            var existingQty =
              existingLineIndex >= 0
                ? Math.round(
                  ((parseFloat(cartObj.items[existingLineIndex].properties.qty) ||
                    cartObj.items[existingLineIndex].quantity) *
                    10),
                ) / 10
                : 0;
            var totalQtyToQuote = Math.round((existingQty + quantity) * 10) / 10;

            var cartData = {
              variants: [
                {
                  variantId: parseInt(variantId),
                  qty: totalQtyToQuote,
                  material: material,
                  prm: prm,
                  properties: properties,
                },
              ],
              session: (window.ShopifyAnalytics &&
                window.ShopifyAnalytics.lib &&
                typeof window.ShopifyAnalytics.lib.user === "function" &&
                window.ShopifyAnalytics.lib.user() &&
                typeof window.ShopifyAnalytics.lib.user().traits === "function" &&
                window.ShopifyAnalytics.lib.user().traits())
                ? window.ShopifyAnalytics.lib.user().traits().uniqToken
                : "",
              token: "KIi16KkJ3HEjwydO7S582tKkESRZJsaJDlH2ckDXZ1OJjmHp6W",
              customer: sapId,
            };

            console.log('[Normal ATC] calling spicers /cart API with payload:', cartData);
            var url = theme.ENV.apiUrl + "/cart?token=" + token;
            var result = await theme.utils.fetch(url, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(cartData),
            });

            var quotedItem = Array.isArray(result) ? result[0] : result;
            console.log('[ATC] Spicers API Full Response:', result);
            console.log('[ATC] quotedItem:', quotedItem);
            if (!quotedItem || !quotedItem.id)
              throw new Error("Pricing API Error");

            var finalProperties = _objectSpread(
              _objectSpread({}, properties),
              quotedItem.properties || {},
            );
            finalProperties.qty = totalQtyToQuote;
            finalProperties._hmac = quotedItem.hmac;

            if (existingLineIndex >= 0) {
              const res = await window.fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  line: existingLineIndex + 1,
                  quantity: 1,
                  properties: finalProperties,
                }),
              });
              if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData.description || errData.message || "Error adding to cart");
              }
            } else {
              const res = await window.fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  items: [
                    {
                      id: quotedItem.id,
                      quantity: 1,
                      properties: finalProperties,
                    },
                  ],
                }),
              });
              if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData.description || errData.message || "Error adding to cart");
              }
            }

            if (typeof refreshCartDrawer === "function") refreshCartDrawer();
            theme.utils.updateBadge();
            $btn.removeClass("is-loading");
          } catch (err) {
            console.error("[ATC] Error:", err);
            window.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { data: { message: err.message } } }));
            // Open drawer but skip DOM update to avoid wiping the error message
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { didError: true } } }));
            $btn.removeClass("is-loading");
          }
        });
    });
  };

  theme.initStockManagement = function () {
    document.addEventListener("stock:update", function (event) {
      var material = event.detail.material;
      var prm = event.detail.prm;
      if (material) theme.updateStockDisplay(material, document.body);
      if (material && prm)
        theme.updatePriceDisplay(material, prm, document.body);
    });

    document.addEventListener("variant:update", function (event) {
      var picker = event.target;
      if (picker && picker.tagName === "VARIANT-PICKER") {
        var opt = picker.querySelector(
          "select option:checked, fieldset input:checked",
        );
        if (opt) {
          var material = opt.dataset.material;
          var prm = opt.dataset.prmValue;
          if (material) theme.updateStockDisplay(material, document.body);
          if (material && prm)
            theme.updatePriceDisplay(material, prm, document.body);
        }
        const targetContainer = picker.closest(
          ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
        );
        if (
          targetContainer &&
          typeof theme.initCustomVariantSync === "function"
        ) {
          setTimeout(
            () =>
              theme.initCustomVariantSync(targetContainer, {
                skipInitialSync: true,
              }),
            20,
          );
        }
      }
    });

    // ✅ NEW: Run initialization for both guest and logged-in users
    /* OLD:
        if (window.customer && window.customer.id) {
        */
    if (true) {
      // 1. Initialize bulk rows and grid cards
      document
        .querySelectorAll(".variant-row, .bulk-order.mobile .inner-grid")
        .forEach(function (row) {
          var material = row.dataset.material;
          if (!material) {
            var btnEl = row.querySelector(".add-to-cart");
            if (btnEl) material = btnEl.dataset.material;
          }
          if (!material) {
            var inputEl = row.querySelector("input[name='quantity']");
            if (inputEl) material = inputEl.dataset.material;
          }
          if (!material) {
            var skuEl = row.querySelector(".sku");
            if (skuEl) material = skuEl.textContent.replace("SKU:", "").trim();
          }
          if (material) {
            // ✅ FIX 3: Read actual qty from the row's qty input (if present), not hardcoded 1
            var qtyInputEl = row.querySelector('input[data-index], input[id*="qty-"]');
            var rowQty = qtyInputEl ? (parseInt(qtyInputEl.value) || 1) : 1;
            theme.updateStockDisplay(material, row, rowQty);
          }

          var prm = row.dataset.prmValue;
          if (material && prm) {
            theme.updatePriceDisplay(material, prm, row);
          }
        });

      document.querySelectorAll("product-card").forEach(function (card) {
        var inputEl = card.querySelector(
          '.quick-add__product-form-component input[name="id"]',
        );
        if (inputEl && inputEl.dataset.material) {
          theme.updateStockDisplay(inputEl.dataset.material, card);
          if (inputEl.dataset.prmValue)
            theme.updatePriceDisplay(
              inputEl.dataset.material,
              inputEl.dataset.prmValue,
              card,
            );
        }
      });

      // 2. Initialize main PDP variant / active modal variant pickers
      document.querySelectorAll("variant-picker").forEach(function (picker) {
        var opt =
          picker.querySelector(
            "select option[selected], fieldset input:checked",
          ) || picker.querySelector("select option");
        if (opt && opt.dataset.material) {
          const container = picker.closest(
            ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
          );
          // If in PDP area, use document.body for global price indicators; otherwise use container or body
          const target =
            container &&
              !container.classList.contains("quick-add-modal__content")
              ? document.body
              : container || document.body;
          theme.updateStockDisplay(opt.dataset.material, target);
          if (opt.dataset.prmValue)
            theme.updatePriceDisplay(
              opt.dataset.material,
              opt.dataset.prmValue,
              target,
            );
        }
      });

      // 3. Handle products with only a default variant (e.g. enquiry template)
      // No variant-picker is rendered for these, so we read from the hidden .default-variant-data element.
      document.querySelectorAll(".default-variant-data").forEach(function (el) {
        var material = el.dataset.defaultMaterial;
        var prm = el.dataset.defaultPrm;
        if (material) theme.updateStockDisplay(material, document.body);
        if (material && prm)
          theme.updatePriceDisplay(material, prm, document.body);
      });
    }

    $(document).on("click", ".add-to-cart", function (e) {
      theme.handleAddToCart(e);
    });

    $(document).on("blur", 'input[name="quantity"]', function () {
      theme.quantityRules.validateOnBlur($(this));
    });

    // Initialize custom variant sync for all custom blocks found on page
    document
      .querySelectorAll("script[data-custom-variants-json]")
      .forEach(function (json) {
        const container = json.closest(
          ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
        );
        if (container && typeof theme.initCustomVariantSync === "function") {
          const customContainer =
            container.querySelector("[data-custom-variants]") ||
            (container.matches("[data-custom-variants]") ? container : null);
          if (
            customContainer &&
            typeof window.initCustomVariantUI === "function"
          ) {
            window.initCustomVariantUI(customContainer);
          }
          theme.initCustomVariantSync(container, { skipInitialSync: true });
        }
      });
  };

  window.initCustomVariantUI = function (container) {
    if (!container) return;
    if (container.dataset.customUiInitialized) return;
    container.dataset.customUiInitialized = "true";

    // Look for JSON in: 1) closest ancestor wrapper, 2) sibling of parent, 3) document
    const wrapper =
      container.closest(
        ".quick-add-modal__content, [data-product-grid-content], .product-details, .product-information",
      ) || container.parentNode;
    const jsonEl =
      (wrapper ? wrapper.querySelector("[data-custom-variants-json]") : null) ||
      document.querySelector("[data-custom-variants-json]");
    if (!jsonEl) return;

    let variantsJson = [];
    try {
      variantsJson = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const selects = container.querySelectorAll("select.variant-option__select");
    const radioInputs = container.querySelectorAll('input[type="radio"]');

    const normalize = (val) => {
      if (val === null || val === undefined) return "0";
      let s = String(val).trim().toLowerCase().replace(/\s+/g, "");
      if (s === "" || s === "0") return "0";

      if (s.indexOf("x") !== -1) {
        return s
          .split("x")
          .map((p) => normalize(p))
          .join("x");
      }

      if (!isNaN(s) && !isNaN(parseFloat(s))) return String(parseFloat(s));
      return s;
    };

    const normalizeColor = (val) => {
      if (val === null || val === undefined) return "0";
      let s = String(val).trim().toLowerCase().replace(/\s+/g, "");
      if (s === "satin") return "satindigital";
      if (s === "gloss") return "glossdigital";
      return s;
    };

    // Helper to get current selections
    function getSelections() {
      const selections = {};
      // Dropdowns
      container.querySelectorAll("[data-name]").forEach((el) => {
        if (el.tagName === "SELECT") {
          selections[el.dataset.name] = el.value;
        } else if (el.tagName === "INPUT" && el.checked) {
          selections[el.dataset.name] = el.value;
        }
      });
      return selections;
    }

    // Helper to update UI states
    function updateOptions() {
      const selections = getSelections();
      const keys = Object.keys(selections);

      // We update options in a specific order: Color -> GSM -> (Sheet Size or Width)

      // 1. Update GSM based on Color (if both exist)
      if (
        keys.includes("color") &&
        container.querySelector('[data-name="gsm"]')
      ) {
        const availableGSMs = [
          ...new Set(
            variantsJson
              .filter((v) => normalizeColor(v.color) === normalizeColor(selections.color))
              .map((v) => v.gsm),
          ),
        ];
        updateOptionUI("gsm", availableGSMs);
      }

      // Refresh selections after potentially auto-switching GSM
      const updatedSelections = getSelections();

      // 2. Update Sheet Size based on Color & GSM
      if (container.querySelector('[data-name="sheet_size"]')) {
        const availableSheets = [
          ...new Set(
            variantsJson
              .filter((v) => {
                let match = true;
                if (updatedSelections.color)
                  match = match && normalizeColor(v.color) === normalizeColor(updatedSelections.color);
                if (updatedSelections.gsm)
                  match = match && normalize(v.gsm) === normalize(updatedSelections.gsm);
                if (updatedSelections.thickness)
                  match = match && normalize(v.thickness) === normalize(updatedSelections.thickness);
                return match;
              })
              .map((v) => v.sheet),
          ),
        ];
        updateOptionUI("sheet_size", availableSheets);
      }

      // 3. Update Width based on Color & GSM
      if (container.querySelector('[data-name="width"]')) {
        const availableWidths = [
          ...new Set(
            variantsJson
              .filter((v) => {
                let match = true;
                if (updatedSelections.color)
                  match = match && normalizeColor(v.color) === normalizeColor(updatedSelections.color);
                if (updatedSelections.gsm)
                  match = match && normalize(v.gsm) === normalize(updatedSelections.gsm);
                if (updatedSelections.thickness)
                  match = match && normalize(v.thickness) === normalize(updatedSelections.thickness);
                return match;
              })
              .map((v) => v.width),
          ),
        ];
        updateOptionUI("width", availableWidths);
      }

      // Finally, find matching variant and update main picker
      syncWithMainPicker();
    }

    function updateOptionUI(name, availableValues) {
      const options = container.querySelectorAll(`[data-name="${name}"]`);
      let firstAvailableValue = null;
      let currentStillAvailable = false;

      options.forEach((opt) => {
        if (opt.tagName === "SELECT") {
          Array.from(opt.options).forEach((o) => {
            const isAvail = availableValues.some(
              (av) => normalize(av) === normalize(o.value)
            );
            o.disabled = !isAvail;
            if (isAvail && !firstAvailableValue) firstAvailableValue = o.value;
            if (isAvail && normalize(o.value) === normalize(opt.value)) currentStillAvailable = true;
          });

          if (!currentStillAvailable && firstAvailableValue) {
            opt.value = firstAvailableValue;
          }
        } else {
          // Radios
          const label = opt.closest(".variant-option__button-label");
          const isAvail = availableValues.some(
            (av) => normalize(av) === normalize(opt.value)
          );

          if (!isAvail) {
            if (label) label.classList.add("is-disabled");
            opt.disabled = true;
          } else {
            if (label) label.classList.remove("is-disabled");
            opt.disabled = false;
            if (!firstAvailableValue) firstAvailableValue = opt.value;
            if (opt.checked) currentStillAvailable = true;
          }
        }
      });

      // Auto-select first available if current selection is now disabled
      if (!currentStillAvailable && firstAvailableValue) {
        const toCheck = Array.from(
          container.querySelectorAll(`input[data-name="${name}"]`)
        ).find((el) => normalize(el.value) === normalize(firstAvailableValue));
        if (toCheck) {
          toCheck.checked = true;
          // Trigger change to update next level down
          updateOptions();
        }
      }
    }

    function syncWithMainPicker() {
      const s = getSelections();
      const match = variantsJson.find(
        (v) =>
          normalizeColor(v.color) === normalizeColor(s.color) &&
          normalize(v.gsm) === normalize(s.gsm) &&
          (s.thickness ? normalize(v.thickness) === normalize(s.thickness) : true) &&
          (s.sheet_size ? normalize(v.sheet) === normalize(s.sheet_size) : true) &&
          (s.width ? normalize(v.width) === normalize(s.width) : true),
      );

      if (match) {
        // Update Request a Sample Drawer Info
        const sampleVariantTitle = document.querySelector(
          "[data-sample-variant-title]",
        );
        const sampleVariantInput = document.querySelector(
          "#sample-variant-input",
        );

        if (sampleVariantTitle) {
          sampleVariantTitle.textContent = match.title;
        }
        if (sampleVariantInput) {
          sampleVariantInput.value = match.title;
        }

        // Let theme.initCustomVariantSync handle the actual mainPicker syncing
        // so we don't interfere with the events being dispatched to the Shopify form.
      }
    }

    // Listen for changes
    container.addEventListener("change", (e) => {
      if (e.target.matches("[data-name]")) {
        updateOptions();
      }
    });

    // Expose so theme.initCustomVariantSync can refresh disabled states after
    // it programmatically checks radios (e.g. mainToCustom sync), which does
    // not fire native "change" events and would otherwise leave stale
    // is-disabled classes on the newly selected variant's options.
    container._refreshCustomVariantOptions = updateOptions;

    // Initial run
    updateOptions();

    // Re-run sorting after dependencies
    const dropdowns = container.querySelectorAll(
      "select.variant-option__select",
    );
    dropdowns.forEach((select) => sortSelectOptions(select));
    const fieldsets = container.querySelectorAll("fieldset.variant-option");
    fieldsets.forEach((fieldset) => sortRadioGroup(fieldset));

    function extractNumber(str) {
      if (!str) return 999999;
      const i_down = str.toLowerCase().trim();
      const predefined = {
        'a5': 1, 'a4': 2, 'a4+': 3, 'a3': 4, 'a3+': 5,
        'a2': 6, 'a2+': 7, 'a1': 8, 'a1+': 9, 'a0': 10,
        'b5': 11, 'b4': 12, 'b3': 13, 'b2': 14, 'b1': 15, 'b0': 16
      };
      if (predefined[i_down]) return predefined[i_down];

      const match = str.match(/(\d+(?:\.\d+)?)/);
      return match ? 100000 + parseFloat(match[1]) : 999999;
    }

    function sortSelectOptions(select) {
      const options = Array.from(select.options);
      if (options.length <= 1) return;
      const selectedVal = select.value;
      options.sort((a, b) => extractNumber(a.text) - extractNumber(b.text));
      options.forEach((opt) => select.appendChild(opt));
      select.value = selectedVal;
    }

    function sortRadioGroup(fieldset) {
      const labels = Array.from(
        fieldset.querySelectorAll("label.variant-option__button-label"),
      );
      if (labels.length <= 1) return;
      let checkedValue = null;
      labels.forEach((label) => {
        const radio = label.querySelector('input[type="radio"]');
        if (radio && radio.checked) checkedValue = radio.value;
      });
      labels.sort((a, b) => {
        const textA =
          a.querySelector("span.variant-option__button-label__text")
            ?.innerText || "";
        const textB =
          b.querySelector("span.variant-option__button-label__text")
            ?.innerText || "";
        return extractNumber(textA) - extractNumber(textB);
      });
      labels.forEach((label) => fieldset.appendChild(label));
      if (checkedValue) {
        const radioToCheck = fieldset.querySelector(
          `input[type="radio"][value="${checkedValue.replace(/"/g, '\\"')}"]`,
        );
        if (radioToCheck) radioToCheck.checked = true;
      }
    }
  };

  theme.initCustomVariantSync = function (container, options) {
    if (!container) return;
    const skipSyncToMain = options && options.skipInitialSync;

    /**
     * Updates the .quntity-note[data-moq-note] element with the effective
     * order multiple from the matched variant JSON. A whole-number
     * lineal_metres (full-roll length) acts as the multiple when there is no
     * explicit order_multiple, matching the previous theme's roll-ordering rule.
     * Also syncs qty input step/min so +/- buttons respect MOQ or roll length.
     */
    const updateMoqFromVariant = (matchedVariant, targetContainer) => {
      const rules = theme.quantityRules.fromVariant(matchedVariant);
      const moq = rules.moq;

      // Find the MOQ note div — could be in a parent section or the product-information wrapper
      const section =
        targetContainer.closest('.shopify-section, .product-information, .product-details') ||
        document.body;
      const moqNote = section.querySelector('.quntity-note[data-moq-note]');
      if (moqNote) {
        if (moq > 1) {
          moqNote.setAttribute('data-multiplier', moq);
          moqNote.style.display = '';
          // Update the inline number in "Quantity ordered in multiples of X"
          const moqValueSpan = moqNote.querySelector('[data-moq-value]');
          if (moqValueSpan) moqValueSpan.textContent = moq;
        } else {
          moqNote.removeAttribute('data-multiplier');
          moqNote.style.display = 'none';
        }
      }
      const qtyInput = section.querySelector('input[name="quantity"]');
      if (qtyInput) {
        theme.quantityRules.applyToInput(qtyInput, rules);
        const resetVal = rules.isDecimalLm ? 1 : moq;
        if (parseFloat(qtyInput.value) !== resetVal) {
          qtyInput.value = resetVal;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    const updateVariantLogic = (
      targetContainer,
      direction = "customToMain",
    ) => {
      const variantPicker = targetContainer.querySelector("variant-picker");
      const mainSelects = targetContainer.querySelectorAll(
        'select[name^="options["], variant-picker select:not([data-name])',
      );
      const mainInputs = targetContainer.querySelectorAll(
        'variant-picker input[type="radio"]',
      );

      const jsonScript = targetContainer.querySelector(
        "script[data-custom-variants-json]",
      );
      let allVariants = [];
      if (jsonScript) {
        try {
          allVariants = JSON.parse(jsonScript.textContent);
        } catch (e) {
          console.error("Error parsing custom variants JSON", e);
        }
      }

      const normalize = (val) => {
        if (val === null || val === undefined) return "0";
        let s = String(val).trim().toLowerCase().replace(/\s+/g, "");
        if (s === "" || s === "0") return "0";

        if (s.indexOf("x") !== -1) {
          return s
            .split("x")
            .map((p) => normalize(p))
            .join("x");
        }

        if (!isNaN(s) && !isNaN(parseFloat(s))) return String(parseFloat(s));
        return s;
      };

      const normalizeColor = (val) => {
        if (val === null || val === undefined) return "0";
        let s = String(val).trim().toLowerCase().replace(/\s+/g, "");
        if (s === "satin") return "satindigital";
        if (s === "gloss") return "glossdigital";
        return s;
      };

      const getCustomValue = (name) => {
        const select = targetContainer.querySelector(
          `select[data-name="${name}"]`,
        );
        if (select) return select.value;
        const checked = targetContainer.querySelector(
          `input[data-name="${name}"]:checked`,
        );
        return checked ? checked.value : null;
      };

      const setCustomValue = (name, value) => {
        const normalizedVal = normalize(value);
        targetContainer
          .querySelectorAll(`[data-name="${name}"]`)
          .forEach((el) => {
            if (el.tagName === "SELECT") {
              // For select, try to find an option that matches normalized value
              const targetOpt = Array.from(el.options).find(
                (opt) => normalize(opt.value) === normalizedVal,
              );
              if (targetOpt) el.value = targetOpt.value;
            } else if (el.tagName === "INPUT" && el.type === "radio") {
              el.checked = normalize(el.value) === normalizedVal;
              if (el.parentElement)
                el.parentElement.classList.toggle("is-selected", el.checked);
            }
          });
      };

      const syncMainToCustom = () => {
        // Find currently selected variant ID from variant-picker
        let selectedVariantId = null;
        if (variantPicker) {
          // 1. Try to get the true selected variant from the JSON script
          const jsonScript = variantPicker.querySelector(
            'script[type="application/json"]',
          );
          if (jsonScript) {
            try {
              const pickerData = JSON.parse(jsonScript.textContent);
              if (pickerData && pickerData.id) {
                selectedVariantId = pickerData.id;
              }
            } catch (e) { }
          }

          // 2. Try to get from a master select if JSON fails
          if (!selectedVariantId) {
            const masterSelect =
              variantPicker.querySelector('select[name="id"]');
            if (masterSelect) selectedVariantId = masterSelect.value;
            else {
              // Fallback to selected options
              const selectedOpts = Array.from(
                variantPicker.querySelectorAll(
                  "select option[selected], input:checked",
                ),
              );
              // If there is an option that has data-variant-id, use it
              const withId = selectedOpts.find((opt) => opt.dataset.variantId);
              if (withId) selectedVariantId = withId.dataset.variantId;
            }
          }
        }

        if (!selectedVariantId && allVariants.length > 0) {
          // One last try: if there's only one variant, or it's the first available
          selectedVariantId = allVariants[0].id;
        }

        if (selectedVariantId) {
          const match = allVariants.find(
            (v) => String(v.id) === String(selectedVariantId),
          );
          if (match) {
            setCustomValue("color", match.color);
            setCustomValue("gsm", match.gsm);
            setCustomValue("thickness", match.thickness);
            setCustomValue("sheet_size", match.sheet);
            setCustomValue("width", match.width);
            // Also update MOQ for the current selected variant
            updateMoqFromVariant(match, targetContainer);
            // Recalculate which options are enabled/disabled now that the
            // real color/gsm/thickness are set, otherwise the newly selected
            // sheet_size (or other cascaded option) can stay marked is-disabled
            // from the stale default selection computed on initial render.
            const customUiContainer = targetContainer.querySelector(
              "[data-custom-variants]",
            );
            if (
              customUiContainer &&
              typeof customUiContainer._refreshCustomVariantOptions === "function"
            ) {
              customUiContainer._refreshCustomVariantOptions();
            }
          }
        }
      };

      const syncCustomToMain = () => {
        if (allVariants.length === 0) return;

        const color = getCustomValue("color");
        const gsm = getCustomValue("gsm");
        const thickness = getCustomValue("thickness");
        const sheet = getCustomValue("sheet_size");
        const width = getCustomValue("width");

        // Check which fields are actually present in the DOM
        const hasColor = !!targetContainer.querySelector('[data-name="color"]');
        const hasGsm = !!targetContainer.querySelector('[data-name="gsm"]');
        const hasThickness = !!targetContainer.querySelector('[data-name="thickness"]');
        const hasSheet = !!targetContainer.querySelector(
          '[data-name="sheet_size"]',
        );
        const hasWidth = !!targetContainer.querySelector('[data-name="width"]');

        // 1. Precise match on available fields in the JSON
        let match = allVariants.find(
          (v) =>
            (!hasColor || normalizeColor(v.color) === normalizeColor(color)) &&
            (!hasGsm || normalize(v.gsm) === normalize(gsm)) &&
            (!hasThickness || normalize(v.thickness) === normalize(thickness)) &&
            (!hasSheet || normalize(v.sheet) === normalize(sheet)) &&
            (!hasWidth || normalize(v.width) === normalize(width)),
        );

        // 2. Fallbacks - drop the least significant fields first (width, then
        // sheet, then thickness) but NEVER drop color/gsm: matching a variant
        // from another gsm silently reverts the user's selection on the next
        // mainToCustom sync (e.g. variants whose sheet_size metafield is empty).
        if (!match) {
          match = allVariants.find(
            (v) =>
              (!hasColor || normalizeColor(v.color) === normalizeColor(color)) &&
              (!hasGsm || normalize(v.gsm) === normalize(gsm)) &&
              (!hasThickness || normalize(v.thickness) === normalize(thickness)) &&
              (!hasSheet || normalize(v.sheet) === normalize(sheet)),
          );
        }
        if (!match) {
          match = allVariants.find(
            (v) =>
              (!hasColor || normalizeColor(v.color) === normalizeColor(color)) &&
              (!hasGsm || normalize(v.gsm) === normalize(gsm)) &&
              (!hasThickness || normalize(v.thickness) === normalize(thickness)),
          );
        }
        if (!match) {
          match = allVariants.find(
            (v) =>
              (!hasColor || normalizeColor(v.color) === normalizeColor(color)) &&
              (!hasGsm || normalize(v.gsm) === normalize(gsm)),
          );
        }

        if (match) {
          // Update MOQ note and qty input based on variant-level order_multiple
          updateMoqFromVariant(match, targetContainer);

          let changed = false;
          let lastTarget = null;

          // Helper to update a select element
          const updateSelect = (select, value) => {
            if (select) {
              if (select.value !== value) {
                select.value = value;
                for (const opt of select.options) {
                  if (opt.value === value) {
                    opt.setAttribute("selected", "selected");
                  } else {
                    opt.removeAttribute("selected");
                  }
                }
                console.log("[CustomVariant] Updated SELECT to:", value);
              }
              changed = true;
              lastTarget = select;
            }
          };

          // Find all native selects (exclude custom variants which have data-name)
          const nativeSelects = Array.from(
            container.querySelectorAll("select:not([data-name])"),
          ).filter((s) => s.name && s.name.includes("options["));
          const nativeFieldsets = container.querySelectorAll(
            "fieldset.variant-option",
          );

          console.log(
            `[CustomVariant] DOM Scan: found ${nativeSelects.length} native selects, ${nativeFieldsets.length} native fieldsets in container.`,
          );

          // Method 0: Exact ID match (Fallback if inputs have data-variant-id)
          const exactOption = container.querySelector(
            `option[data-variant-id="${match.id}"]`,
          );
          if (exactOption) {
            updateSelect(exactOption.closest("select"), exactOption.value);
          } else {
            const exactInput = container.querySelector(
              `input[type="radio"][data-variant-id="${match.id}"]`,
            );
            if (exactInput) {
              if (!exactInput.checked) {
                exactInput.checked = true;
                console.log(
                  "[CustomVariant] Updated exact INPUT for variant ID",
                );
              }
              changed = true;
              lastTarget = exactInput;
            }
          }

          // Method 1: Sync by option label values
          if (!changed && match.options && match.options.length > 0) {
            match.options.forEach((optVal, idx) => {
              const normalizedOpt = normalize(optVal);
              const select = nativeSelects[idx];

              if (select) {
                const targetOpt = Array.from(select.options).find(
                  (o) => normalize(o.value) === normalizedOpt,
                );
                if (targetOpt) {
                  updateSelect(select, targetOpt.value);
                }
              } else {
                const fieldset = nativeFieldsets[idx];
                if (fieldset) {
                  const inputs = fieldset.querySelectorAll(
                    'input[type="radio"]',
                  );
                  const targetInput = Array.from(inputs).find(
                    (i) => normalize(i.value) === normalizedOpt,
                  );
                  if (targetInput) {
                    if (!targetInput.checked) {
                      targetInput.checked = true;
                      console.log(
                        `[CustomVariant] Updated RADIO for option ${idx}:`,
                        optVal,
                      );
                    }
                    changed = true;
                    lastTarget = targetInput;
                  }
                }
              }
            });
          }

          console.log(
            `[CustomVariant] Finished update loop. changed: ${changed}, lastTarget:`,
            lastTarget,
          );

          // Fire native change event → triggers full Shopify update chain
          if (lastTarget) {
            console.log(
              `[CustomVariant] Dispatching change event on lastTarget`,
            );
            lastTarget.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            const anyInput = container.querySelector(
              'select[name^="options["], fieldset.variant-option input[type="radio"]',
            );
            if (anyInput) {
              console.log(
                `[CustomVariant] Dispatching change event on arbitrary input (ultimate fallback)`,
              );
              anyInput.dispatchEvent(new Event("change", { bubbles: true }));
            } else {
              console.error(
                `[CustomVariant] CRITICAL: No native input found to dispatch event! Container HTML snapshot:`,
                container.innerHTML.substring(0, 500) + "...",
              );
            }
          }
        }
      };

      if (direction === "mainToCustom") syncMainToCustom();
      else syncCustomToMain();
    };

    if (!container.dataset.customSyncInitialized) {
      container.dataset.customSyncInitialized = "true";
      container.addEventListener("change", (e) => {
        if (e.target.dataset.name) {
          const target =
            e.target.closest(
              ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
            ) || container;
          updateVariantLogic(target, "customToMain");
        }
      });

      // Listen for native variant updates to sync back to custom
      document.addEventListener("variant:update", (event) => {
        const target =
          event.target.closest(
            ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
          ) || container;
        updateVariantLogic(target, "mainToCustom");
      });
    }

    const firstCustom = container.querySelector("[data-name]");
    if (firstCustom) {
      const target =
        firstCustom.closest(
          ".quick-add-modal__content, .product-information, .product-details, [data-product-grid-content]",
        ) || container;
      updateVariantLogic(
        target,
        skipSyncToMain ? "mainToCustom" : "customToMain",
      );
    }
  };

  window.theme = theme;
})(jQuery);
